export class EventoModel {
  public id!: number;
  public tipologia!: string;
  public oggetto!: string;
}
